import { T } from '@angular/cdk/keycodes';
import { CommonModule } from '@angular/common';
import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-activity-totals',
    imports: [CommonModule, MatCardModule, TranslatePipe],
    templateUrl: './activity-totals.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './activity-totals.component.scss'
})
export class ActivityTotalsComponent {
    @Input() automatic: any[] = [];
    @Input() manual: any[] = [];
}
